import * as Sentry from '@sentry/react';

// Initialize Sentry
export const initSentry = () => {
  // Only initialize Sentry if DSN is provided
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.warn('Sentry DSN not configured. Error tracking disabled.');
    return;
  }

  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of transactions for performance monitoring

    // Session Replay
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors

    // Environment
    environment: import.meta.env.MODE || 'development',

    // Release tracking
    release: import.meta.env.VITE_APP_VERSION || 'development',

    // Before send hook to filter sensitive data
    beforeSend(event, _hint) {
      // Filter out localStorage data from breadcrumbs
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.filter(
          breadcrumb => !breadcrumb.message?.includes('localStorage')
        );
      }

      // Remove sensitive context
      if (event.contexts) {
        delete event.contexts.localStorage;
      }

      return event;
    },
  });
};

// Export Sentry for use in catch blocks
export { Sentry };
